



















































import Vue from "vue";
import {Component, Prop} from 'vue-property-decorator'
import {Decimal} from 'decimal.js';

import SkuList from "./SkuList.vue";
import CashoutWalletForm from "./CashoutWalletForm.vue";
import CashoutCheckout from "./CashoutCheckout.vue";
import CashoutModalError from "./CashoutModalError.vue";
import CashoutModal2FA from "./CashoutModal2FA.vue";
import CashoutModalValueResolve from "./CashoutModalValueResolve.vue";
import CashoutModalPleaseWait from "./CashoutModalPleaseWait.vue";
import DebugTools from "./DebugTools.vue";

import {CashoutData, Sku} from "../models";
import {cashoutEventBus, CashoutEvents, CheckoutErrorMode, CheckoutErrorModes} from "../bus";
import SkuImage from "./SkuImage";

@Component({
    components: {
        CashoutCheckout,
        CashoutModal2FA,
        CashoutModalError,
        CashoutModalPleaseWait,
        CashoutModalValueResolve,
        CashoutWalletForm,
        DebugTools,
        SkuImage,
        SkuList,
    }
})
export default class CashoutForm extends Vue {
    @Prop()
    cashoutData!: CashoutData;
    @Prop()
    skus!: Sku[];

    // Set to true to trigger image preload
    preloadImages: boolean = false;

    step: number = 1;
    states = [
        'wallet',
        'select-product',
        'checkout'
    ];
    currentState = this.states[0];

    viewportWidth: number = 0;

    mounted(): void {
        // Update screen width when page is resized
        this.updateViewportWidth();
        window.addEventListener('resize', this.updateViewportWidth);

        // Force first fetch of rate
        this.cashoutData.updateRate(true);

        cashoutEventBus.$on(CashoutEvents.WALLET_FORM_SUBMITTED, () => this.switchState('select-product'));
        cashoutEventBus.$on(CashoutEvents.WALLET_FORM_ADJUST, this.adjustWallet);
        cashoutEventBus.$on(CashoutEvents.SKU_SELECT, this.skuSelect);

        cashoutEventBus.$on(CashoutEvents.CHECKOUT_START, this.checkoutStart);
        cashoutEventBus.$on(CashoutEvents.CHECKOUT_ERROR, this.checkoutError);
        cashoutEventBus.$on(CashoutEvents.CHECKOUT_FAILURE, this.checkoutFailure);

        window.addEventListener('popstate', this.popState.bind(this));

        if (this.isMultiStep) {
            this.switchState(this.states[0]);
            setTimeout(() => this.preloadImages = true, 800);
        }
    }

    updateViewportWidth(): void {
        this.viewportWidth = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
    }

    get isMultiStep(): boolean {
        return this.viewportWidth < 992;
    }

    isCurrentState(stateName: string): boolean {
        if (!this.isMultiStep) return true;
        return this.currentState === stateName;
    }

    switchState(stateName: string, pushState: boolean = true): void {
        if (this.cashoutData.orderInProgress) return;
        this.currentState = stateName;
        if (pushState) history.pushState(stateName, undefined, stateName);
        let header = document.querySelector('header');
        if (this.isMultiStep && header) {
            // Scroll to top of viewport as new step and we don't want to be halfway down it
            header.scrollIntoView(true);
        }
    }

    popState(event: PopStateEvent) {
        // Fires when back / forward buttons are used
        if (!event.state) return;
        this.switchState(event.state, false)
    }

    back(): void {
        history.back()
    }

    adjustWallet(): void {
        if (this.cashoutData.orderInProgress) return;
        if (this.isMultiStep) this.switchState('wallet');
        else {
            let element = document.querySelector('#cashout-wallet-form');
            // Smooth mode does not from this context, make the window do it
            setTimeout(() => {
                if (!element) throw "Cannot find the wallet form";
                element.scrollIntoView({behavior: "smooth"})
            }, 10);

        }
    }

    skuSelect(skuId: number) {
        let sku = this.cashoutData.getSkuFromId(skuId);
        if (!sku) throw new Error("Invalid sku");

        if (!this.cashoutData.minFiatAmount) return;

        // Value of the final card
        let cashoutValue = sku.cashoutValue(this.cashoutData.fiatAmount);

        // Check our fiat amount allows for selecting this product, if not fire event to resolve
        sku.availableForValue(cashoutValue, this.cashoutData.minFiatAmount).then((available: boolean) => {
            if (available) {
                this.skuSelected(sku!)
            } else {
                cashoutEventBus.$emit(CashoutEvents.SKU_SELECT_ADJUSTMENT_REQUIRED, sku!);
            }
        }).catch((err) => {
            throw new Error(`Unable to check sku.availableForValue for ${sku!.code}: ${err}`)
        });
    }

    skuSelected(sku: Sku): void {
        this.cashoutData.selectedSkuId = sku.id;
        this.cashoutData.lastSelectedSkuId = sku.id;
        this.switchState('checkout')
    }

    checkoutStart() {
        this.cashoutData.orderInProgress = true;
    }

    checkoutError(errorMode: CheckoutErrorMode, message: string) {
        // Server said no
        this.cashoutData.orderInProgress = false;
        switch (errorMode) {
            case CheckoutErrorModes.INSUFFICIENT_FUNDS:
                // Refresh user data
                this.cashoutData.updateUserData();
                this.cashoutData.fiatAmount = new Decimal(0);
                this.switchState('wallet');
                break;
            case CheckoutErrorModes.RATE_NO_LONGER_VALID:
                this.cashoutData.updateRate();
                this.switchState('wallet');
                break;
            case CheckoutErrorModes.VALIDATION_ERROR:
            case CheckoutErrorModes.GENERIC_ERROR:
                this.cashoutData.updateUserData();
                this.cashoutData.updateRate();
                this.switchState('wallet');
                break;
        }
    }

    checkoutFailure() {
        // Server did a 50x
        this.cashoutData.orderInProgress = false;
    }

    modalOpened() {
        // Use BS4 scroll locking
        // document.body.classList.add('modal-open')
    }

    modalClosed() {
        // Use BS4 scroll locking
        // document.body.classList.remove('modal-open')
    }

}
